__turbopack_context__.v({
  "advancedSearchItemListItem": "QuickSearchCompactContent-module__Wfz6Lq__advancedSearchItemListItem",
  "bottomPadding": "QuickSearchCompactContent-module__Wfz6Lq__bottomPadding",
  "hasAiSearchItem": "QuickSearchCompactContent-module__Wfz6Lq__hasAiSearchItem",
  "noResultsContainer": "QuickSearchCompactContent-module__Wfz6Lq__noResultsContainer",
});
